import type { FakeRouteConfig } from 'vite-plugin-fake-server/client';
import { accountStore } from './store/account';

function response<T>(work: () => T) {
  try {
    return { success: true, data: work() };
  } catch (error) {
    // 绑定流程抛出的 BindingError 带稳定错误码，前端据此展示本地化文案。
    const code =
      error instanceof Error ? (error as Error & { code?: unknown }).code : undefined;
    return {
      success: false,
      errorCode: typeof code === 'string' ? code : undefined,
      errorMessage:
        error instanceof Error ? error.message : '请求失败 / Request failed',
    };
  }
}

// 与 user.fake 在同一 Fake 路由模块注册，确保认证与资料/通知共用一份会话。
export const accountRoutes = [
  {
    url: '/account/profile',
    method: 'get',
    response: () => response(() => accountStore.profile()),
  },
  {
    url: '/account/profile',
    method: 'patch',
    response: ({ body }) =>
      response(() =>
        accountStore.updateProfile({
          displayName: body.displayName,
          bio: body.bio,
          region: body.region,
          expectedVersion: body.expectedVersion,
        }),
      ),
  },
  {
    url: '/account/avatar',
    method: 'patch',
    response: ({ body }) => response(() => accountStore.updateAvatar(body.dataUrl)),
  },
  {
    url: '/account/bindings',
    method: 'get',
    response: () => response(() => accountStore.bindings()),
  },
  {
    url: '/account/bindings/code',
    method: 'post',
    response: ({ body }) =>
      response(() =>
        accountStore.sendBindingCode({ channel: body.channel, target: body.target }),
      ),
  },
  {
    url: '/account/bindings/verify',
    method: 'post',
    response: ({ body }) =>
      response(() =>
        accountStore.verifyBinding({
          channel: body.channel,
          target: body.target,
          code: body.code,
        }),
      ),
  },
  {
    url: '/account/notification-settings',
    method: 'get',
    response: () => response(() => accountStore.subscriptions()),
  },
  {
    url: '/account/notification-settings',
    method: 'patch',
    response: ({ body }) =>
      response(() =>
        accountStore.updateSubscriptions({
          systemMessage: body.systemMessage,
          todoTask: body.todoTask,
          userMessage: body.userMessage,
        }),
      ),
  },
  {
    url: '/account/password',
    method: 'post',
    response: ({ body }) =>
      response(() =>
        accountStore.changePassword({
          currentPassword: body.currentPassword,
          newPassword: body.newPassword,
        }),
      ),
  },
  {
    url: '/account/notifications',
    method: 'get',
    response: ({ query }) =>
      response(() =>
        accountStore.notifications({
          page: Number(query.page),
          pageSize: Number(query.pageSize),
          unread: query.unread === 'true',
        }),
      ),
  },
  {
    url: '/account/notifications/:id/read',
    method: 'patch',
    response: ({ params }) => response(() => accountStore.read(String(params.id))),
  },
  {
    url: '/account/notifications/read-all',
    method: 'post',
    response: () => response(() => accountStore.readAll()),
  },
] satisfies Exclude<FakeRouteConfig, FakeRouteConfig[]>[];
